import { render, staticRenderFns } from "./HeaderBanner.vue?vue&type=template&id=36afb2a7&scoped=true"
import script from "./HeaderBanner.vue?vue&type=script&lang=js"
export * from "./HeaderBanner.vue?vue&type=script&lang=js"
import style0 from "./HeaderBanner.vue?vue&type=style&index=0&id=36afb2a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36afb2a7",
  null
  
)

export default component.exports